module.exports = __webpack_public_path__ + "static/media/bridge.2546cd2d.svg";